export default __webpack_public_path__ + "static/media/thumb.b6502c32.jpeg";